import { Box, Button, Typography, useTheme, useMediaQuery, Drawer, IconButton, Tab, Tabs, TextField, FormControl, InputLabel, OutlinedInput, InputAdornment, Card, CardContent } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { tokens } from "../../theme";
import Header from "../../components/Header";
import axios from 'axios';
import { Tooltip } from '@mui/material';
import { AuthContext } from '../../context/AuthContext';
import { useContext, useEffect, useState } from "react";
import SettingsIcon from '@mui/icons-material/Settings';
import CloseIcon from '@mui/icons-material/Close';
import CheckIcon from '@mui/icons-material/Check';
import ClearIcon from '@mui/icons-material/Clear';
import { styled } from '@mui/system';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import HistoryIcon from '@mui/icons-material/History';
import PersonIcon from '@mui/icons-material/Person';
import InfoIcon from '@mui/icons-material/Info';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import Toast from '../../components/Toast';

const ResizableDrawer = styled(Box)(({ width }) => ({
  width: width,
  transition: 'width 0.2s',
  height: '100%',
  position: 'relative',
}));

const ResizeHandle = styled(Box)({
  width: '10px',
  cursor: 'ew-resize',
  backgroundColor: 'transparent',
  position: 'absolute',
  left: -5, // Slightly outside the drawer for easier grabbing
  top: 0,
  height: '100%',
  zIndex: 1,
});

const Drivers = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [suppliers, setSuppliers] = useState(null);
  const [transactions, setTransactions] = useState(null);
  const [selectedSupplier, setSelectedSupplier] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const { currentuser, base_url } = useContext(AuthContext);
  const [tabValue, setTabValue] = useState(0);
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const [pdfUrl, setPdfUrl] = useState('');
  const [vurl, setVurl] = useState('');
  const [remark, setRemark] = useState('');
  const [showRemarkField, setShowRemarkField] = useState(false);
  const [showDeactivateRemarkField, setShowDeactivateRemarkField] = useState(false);
  const [imageUrl, setImageUrl] = useState('');
  const [imageUrld, setImageUrld] = useState('');
  const [drawerWidth, setDrawerWidth] = useState(400); // Initial width
  const [toastOpen, setToastOpen] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastSeverity, setToastSeverity] = useState('success'); // 'success', 'error', 'info', 'warning'

  const handleToastOpen = (message, severity) => {
    setToastMessage(message);
    setToastSeverity(severity);
    setToastOpen(true);
  };

  const handleToastClose = () => {
    setToastOpen(false);
  };

  const handleMouseDown = (event) => {
    const startX = event.clientX;

    const handleMouseMove = (event) => {
      const newWidth = Math.max(200, drawerWidth + (startX - event.clientX));
      setDrawerWidth(newWidth);
    };

    const handleMouseUp = () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };

    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
  };

  const config = {
    headers: {
      'Authorization': `Bearer ${currentuser.accessToken}`
    },
    responseType: 'blob',
  };

  const fetchUsers = async () => {
    try {
      const res = await axios.get(`${base_url}/ethioglobal/docs/pdf/driverdocs_${selectedSupplier?.id}.pdf`, config);
      
      const pdfBlob = new Blob([res.data], { type: 'application/pdf' });
      const pdfUrl = window.URL.createObjectURL(pdfBlob);
      setPdfUrl(pdfUrl);
    } catch (error) {
      console.error("Error fetching driver docs:", error);
    }
  };

  const fetchVehicle = async () => {
    try {
      const res = await axios.get(`${base_url}/ethioglobal/docs/vehicle/vehicledocs_${selectedSupplier?.id}.pdf`, config);
      
      const pdfBlob = new Blob([res.data], { type: 'application/pdf' });
      const pdfUrl = window.URL.createObjectURL(pdfBlob);
      setVurl(pdfUrl);
    } catch (error) {
      console.error("Error fetching vehicle docs:", error);
    }
  };

  const fetchVehiclei = async () => {
    try {
      const res = await axios.get(`${base_url}/ethioglobal/docs/vehicle/vehiclephoto_${selectedSupplier?.id}.JPEG`, config);
      
      const url = URL.createObjectURL(res.data);
      setImageUrl(url);
    } catch (error) {
      console.error("Error fetching vehicle photo:", error);
    }
  };

  const fetchDriveri = async () => {
    try {
      const res = await axios.get(`${base_url}/ethioglobal/docs/driver/driverphoto_${selectedSupplier?.mobilenumber}.jpeg`, config);
      
      const url = URL.createObjectURL(res.data);
      setImageUrld(url);
    } catch (error) {
      console.error("Error fetching vehicle photo:", error);
    }
  };

  useEffect(() => {
    fetchUsers();
    fetchVehicle();
    fetchVehiclei();
    fetchDriveri();
  }, [selectedSupplier]);

  const fetchSuppliers = async () => {
    try {
      const response = await axios.post(`${base_url}/ethioglobal/drivers/all`, config);
      setSuppliers(response.data);
    } catch (error) {
      console.error("Error fetching suppliers:", error);
    }
  };

  useEffect(() => {
    fetchSuppliers();
  }, []);

  const tcolumns = [
    {
      field: "amount",
      headerName: "Ammount",
      flex: 1,
      renderCell: (params) => (
        <Tooltip title={params.value} arrow>
          <span>{params.value}</span>
        </Tooltip>
      ),
    },
    {
      field: "remark",
      headerName: "Remark",
      flex: 1,
      hide: isSmallScreen,
      renderCell: (params) => (
        <Tooltip title={params.value} arrow>
          <span>{params.value}</span>
        </Tooltip>
      ),
    },
    {
      field: "createdAt",
      headerName: "Date",
      flex: 1,
      hide: isSmallScreen,
      renderCell: (params) => {
        const date = new Date(params.value);
        const formattedDate = date.toLocaleString('en-US', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit'
        });
    
        return (
          <Tooltip title={formattedDate} arrow>
            <span>{formattedDate}</span>
          </Tooltip>
        );
      },
    },
    {
      field: "status",
      headerName: "Status",
      flex: 1,
      renderCell: (params) => (
        <Tooltip title={params.value} arrow>
          <span>{params.value}</span>
        </Tooltip>
      ),
    }
  ]

  const columns = [
    {
      field: "firstname",
      headerName: "First Name",
      flex: 1,
      renderCell: (params) => (
        <Tooltip title={params.value} arrow>
          <span>{params.value}</span>
        </Tooltip>
      ),
    },
    {
      field: "middlename",
      headerName: "Middle Name",
      flex: 1,
      hide: isSmallScreen,
      renderCell: (params) => (
        <Tooltip title={params.value} arrow>
          <span>{params.value}</span>
        </Tooltip>
      ),
    },
    {
      field: "lastname",
      headerName: "Last Name",
      flex: 1,
      hide: isSmallScreen,
      renderCell: (params) => (
        <Tooltip title={params.value} arrow>
          <span>{params.value}</span>
        </Tooltip>
      ),
    },
    {
      field: "balance",
      headerName: "Balance",
      flex: 1,
      hide: isSmallScreen,
      renderCell: (params) => (
        <Tooltip title={params.value} arrow>
          <span>{params.value}</span>
        </Tooltip>
      ),
    },
    {
      field: "email",
      headerName: "Email",
      flex: 1,
      hide: isSmallScreen,
      renderCell: (params) => (
        <Tooltip title={params.value} arrow>
          <span>{params.value}</span>
        </Tooltip>
      ),
    },
    {
      field: "mobilenumber",
      headerName: "Phone Number",
      flex: 1,
      renderCell: (params) => (
        <Tooltip title={params.value} arrow>
          <span>{params.value}</span>
        </Tooltip>
      ),
    },
    {
      field: "status",
      headerName: "Status",
      flex: 1,
      hide: isSmallScreen,
      renderCell: (params) => (
        <Tooltip title={params.value} arrow>
          <span>{params.value}</span>
        </Tooltip>
      ),
    },
    {
      field: "createdAt",
      headerName: "Created Date",
      flex: 1,
      hide: isSmallScreen,
      renderCell: (params) => {
        const date = new Date(params.value);
        const formattedDate = date.toLocaleString('en-US', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit'
        });
    
        return (
          <Tooltip title={formattedDate} arrow>
            <span>{formattedDate}</span>
          </Tooltip>
        );
      },
    },
    {
      field: "id",
      headerName: "Details",
      flex: 1,
      renderCell: (params) => {
        return (
          <Tooltip title="Settings" arrow>
            <span
              style={{
                cursor: 'pointer',
                display: 'flex',
                marginRight: 10,
                alignItems: 'center',
                justifyContent: 'flex-end',
                height: '100%',
                width: '100%',
              }}
              onClick={() => {
                setSelectedSupplier(params.row);
                setTransactions(params.row.company?.transactions || null);
                setDrawerOpen(true);
              }}
            >
              <SettingsIcon />
            </span>
          </Tooltip>
        );
      },
    },
  ];

  const handleCloseDrawer = () => {
    setDrawerOpen(false);
    setSelectedSupplier(null);
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleApprove = async () => {
    await axios.post(base_url + '/ethioglobal/supplier/approve', {id: selectedSupplier?.id}, config).then((res) => {
      alert('Approved.');
    }).catch((error) => {
      if(error.status == 404){
        alert('Supplier not found.');
      } else {
        alert('An error occurred.');
      }
    });
  };

  const handleReject = () => {
    setShowRemarkField(true);
  };

  const handleRemarkSubmit = async () => {
    await axios.post(base_url + '/ethioglobal/supplier/reject', {id: selectedSupplier?.id, remark: remark}, config).then((res) => {
      alert('Rejected.');
    }).catch((error) => {
      if(error.status == 404){
        alert('Supplier not found.');
      } else {
        alert('An error occurred.');
      }
    });
    setShowRemarkField(false);
    setRemark('');
  };

  const onSendDeactivate = async () => {
    await axios.post(base_url + '/ethioglobal/supplier/deactivate', {id: selectedSupplier?.id, remark: remark}, config).then((res) => {
      setShowDeactivateRemarkField(false);
      setRemark('');
      handleToastOpen('Driver deactivated!', 'success')
    }).catch((error) => {
      if(error.status == 404){
        alert('Organizatoin not found.');
      } else {
        alert('An error occurred.');
      }
    });
  };

  const onActivate = async () => {
    await axios.post(base_url + '/ethioglobal/supplier/activate', {id: selectedSupplier?.id}, config).then((res) => {
      handleToastOpen('Driver activated!', 'success')
    }).catch((error) => {
      if(error.status == 404){
        alert('Organizatoin not found.');
      } else {
        alert('An error occurred.');
      }
    });
  };

  return (
    <Box m="20px">
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Header subtitle="Drivers List" />
        <Toast
          open={toastOpen}
          handleClose={handleToastClose}
          message={toastMessage}
          severity={toastSeverity}
        />
      </Box>
      <Box
        m="0px 0 0 0"
        height="75vh"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.blueAccent[700],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.primary[400],
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
            backgroundColor: colors.blueAccent[700],
          },
        }}
      >
        {suppliers !== null ? 
          <DataGrid 
            rows={suppliers} 
            columns={columns} 
            pageSize={5} 
            rowsPerPageOptions={[5]} 
          />
          :
          <Typography>No rows to show.</Typography>
        }
      </Box>

      {/* Drawer Component */}
      <Drawer anchor="right" open={drawerOpen} onClose={handleCloseDrawer}>
        {/* <ResizableDrawer width={drawerWidth} sx={{ padding: 2, backgroundColor: `${colors.primary[400]}` }}>
        <ResizeHandle onMouseDown={handleMouseDown} /> */}
        {selectedSupplier?.vehicle || selectedSupplier?.company?.document ? (
        <Box sx={{ width: 480, height: '100%', padding: 2, backgroundColor: `${colors.primary[400]}` }}>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant=""></Typography>
            <IconButton onClick={handleCloseDrawer}>
              <CloseIcon />
            </IconButton>
          </Box>
          {selectedSupplier ? (
            <>
              <>
                {selectedSupplier?.status != 'active' && selectedSupplier?.status != 'deactive' ?
                <Box display="flex" justifyContent="flex-start" alignItems='center' mt={-4}>
                  <Typography variant="body2">Driver and Vehicle Docs:</Typography>
                  <IconButton color="primary" onClick={handleApprove}>
                    <Typography variant="caption" style={{ marginRight: 4 }}>Approve</Typography>
                    <CheckIcon />
                  </IconButton>
                  <IconButton color="secondary" onClick={handleReject}>
                    <Typography variant="caption" style={{ marginRight: 4 }}>Reject</Typography>
                    <ClearIcon />
                  </IconButton>
                </Box>
                :
                <>
                {selectedSupplier?.status == 'active' ?
                <Box display="flex" justifyContent="flex-start" alignItems='center' mt={-4}>
                  <Typography variant="body2">Click</Typography>
                  <IconButton color="secondary" onClick={() => setShowDeactivateRemarkField(true)}>
                    <Typography variant="caption" style={{ marginRight: 4 }}>Deactivate</Typography>
                    <ClearIcon />
                  </IconButton>
                  <Typography variant="body2">to deactivate the Driver</Typography>
                </Box>
                :
                <Box display="flex" justifyContent="flex-start" alignItems='center' mt={-4}>
                  <Typography variant="body2">Click</Typography>
                  <IconButton color="primary" onClick={onActivate}>
                    <Typography variant="caption" style={{ marginRight: 4 }}>Activate</Typography>
                    <CheckIcon />
                  </IconButton>
                  <Typography variant="body2">to activate the Driver</Typography>
                </Box>
                }
                </>
                }
                {showDeactivateRemarkField && (
                <Box mt={2}>
                  <TextField
                    label="Remark"
                    multiline
                    rows={4}
                    variant="outlined"
                    fullWidth
                    value={remark}
                    onChange={(e) => setRemark(e.target.value)}
                  />
                  <Button variant="contained" color="primary" onClick={onSendDeactivate} sx={{ marginTop: 1, marginRight: '20px' }}>
                    Submit Remark
                  </Button>
                  <Button variant="contained" color="primary" onClick={() => setShowRemarkField(false)} sx={{ marginTop: 1 }}>
                    Cancel
                  </Button>
                </Box>
                )}
                {showRemarkField && (
                <Box mt={2}>
                  <TextField
                    label="Remark"
                    multiline
                    rows={4}
                    variant="outlined"
                    fullWidth
                    value={remark}
                    onChange={(e) => setRemark(e.target.value)}
                  />
                  <Button variant="contained" color="primary" onClick={handleRemarkSubmit} sx={{ marginTop: 1, marginRight: '20px' }}>
                    Submit Remark
                  </Button>
                  <Button variant="contained" color="primary" onClick={() => setShowRemarkField(false)} sx={{ marginTop: 1 }}>
                    Cancel
                  </Button>
                </Box>
                )}
              </>

              <Tabs value={tabValue} onChange={handleTabChange} sx={{ marginBottom: 3, }}>
                <Tab label='Info' sx={{textTransform: 'capitalize', fontSize: 10}} />
                {/* icon={<InfoIcon />} */}
                <Tab label='Wallet' sx={{textTransform: 'capitalize', fontSize: 10}} />
                {/* icon={<AccountBalanceWalletIcon />} */}
                <Tab label='Transaction' sx={{textTransform: 'capitalize', fontSize: 10}}/>
                {/* icon={<HistoryIcon />} */}
                <Tab label='Driver Docs' sx={{textTransform: 'capitalize', fontSize: 10}}/>
                {/* icon={<PersonIcon />} */}
                <Tab label='Vehicle Docs' sx={{textTransform: 'capitalize', fontSize: 10}} />
                {/* icon={<DirectionsCarIcon />} */}
              </Tabs>
              {tabValue === 0 && (
                <>
                {selectedSupplier.vehicle ?
                  <>
                  {/* <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ p: 2, backgroundColor: `${colors.primary[700]}`}}> */}
                    <Box sx={{ p: 2, backgroundColor: `${colors.primary[700]}`}} flexDirection="column" display="flex" justifyContent="flex-start" alignItems="flex-start">
                      {/* <Typography variant="">Vehicle Information</Typography> */}
                      <Typography variant="caption">Plate Number: {selectedSupplier?.vehicle?.platenumber}</Typography>
                      <Typography variant="caption">Brand: {selectedSupplier?.vehicle?.brand}</Typography>
                      <Typography variant="caption">Model: {selectedSupplier?.vehicle?.model} {selectedSupplier?.vehicle?.year}</Typography>
                      <Typography variant="caption">Service Type: {selectedSupplier?.vehicle?.servicetype}</Typography>
                      <Typography variant="caption">Fuel Type: {selectedSupplier?.vehicle?.fueltype}</Typography>
                      <Typography variant="caption">Size/Capacity: {selectedSupplier?.vehicle?.size} {selectedSupplier?.vehicle?.capacity}</Typography>
                      
                      {selectedSupplier?.vehicle?.status === 'deactive' && (
                        <>
                          <Typography variant="caption" sx={{ marginTop: 1 }}>Status: {selectedSupplier?.status}</Typography>
                          <Typography variant="caption">Deactivated by: admin</Typography>
                          <Typography variant="caption">Remark: {selectedSupplier?.remark}</Typography>
                        </>
                      )}
                    </Box>
                  {/* </Box> */}
                  <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ mt: 2, p: 2, backgroundColor: `${colors.primary[700]}`}}>
                    {imageUrl ? (
                      <img src={imageUrl} alt="Fetched from backend" style={{ width: '49%', height: '180px', objectFit: 'cover' }} />
                    ) : (
                      <p>Vehicle image...</p>
                    )}
                    {imageUrld ? (
                      <img src={imageUrld} alt="Fetched from backend" style={{ width: '49%', height: '180px', objectFit: 'cover' }} />
                    ) : (
                      <p>Driver image...</p>
                    )}
                  </Box>
                  </>
                  :
                  <>
                    <Typography>Vehicle not registered.</Typography>
                  </>
                  }
                </>
              )}
              {tabValue === 1 && (
                <>
                  <div style={{ display: 'flex', width: '100%', }}>
                    <FormControl fullWidth sx={{ m: 1, flex: 3, }}>
                      <InputLabel sx={{ fontSize: '0.875rem' }} htmlFor="outlined-adornment-amount">Amount</InputLabel>
                      <OutlinedInput
                        id="outlined-adornment-amount"
                        startAdornment={<InputAdornment position="start">$</InputAdornment>}
                        label="Amount"
                        sx={{ height: '40px', '& .MuiOutlinedInput-input': { padding: '8px' } }}
                      />
                    </FormControl>
                    <Button
                      variant="contained"
                      color="success"
                      onClick={() => alert('Recharge success')}
                      sx={{ flex: 1, m: 1, textTransform: 'capitalize' }}
                    >
                      Recharge
                    </Button>
                  </div>
                  <Box sx={{ display: 'flex', width: '100%', marginTop: 1, marginLeft: 1 }}>
                    <Card sx={{ flex: 1, marginRight: 2, backgroundColor: `${colors.primary[700]}` }}>
                      <CardContent>
                        <Typography variant="">Financial Overview</Typography>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', marginTop: 1 }}>
                          <Typography variant="body1">Balance:</Typography>
                          <Typography variant="body1">$ {selectedSupplier?.balance}</Typography>
                        </Box>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', marginTop: 1 }}>
                          <Typography variant="body1">Total Earnings:</Typography>
                          <Typography variant="body1">$ {selectedSupplier?.totalEarnings}</Typography>
                        </Box>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', marginTop: 1 }}>
                          <Typography variant="body1">Today Earnings:</Typography>
                          <Typography variant="body1">$ {selectedSupplier?.todayEarnings}</Typography>
                        </Box>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', marginTop: 1 }}>
                          <Typography variant="body1">Total Tax:</Typography>
                          <Typography variant="body1">$ {selectedSupplier?.totalTax}</Typography>
                        </Box>
                      </CardContent>
                    </Card>

                    <Card sx={{ flex: 1, backgroundColor: `${colors.primary[700]}` }}>
                      <CardContent>
                        <Typography variant="">Order Summary</Typography>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', marginTop: 1 }}>
                          <Typography variant="body1">Orders:</Typography>
                          <Typography variant="body1">{selectedSupplier?.orders}</Typography>
                        </Box>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', marginTop: 1 }}>
                          <Typography variant="body1">Successful:</Typography>
                          <Typography variant="body1">{selectedSupplier?.successfulOrders}</Typography>
                        </Box>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', marginTop: 1 }}>
                          <Typography variant="body1">Cancelled:</Typography>
                          <Typography variant="body1">{selectedSupplier?.cancelledOrders}</Typography>
                        </Box>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', marginTop: 1 }}>
                          <Typography variant="body1">Rejected:</Typography>
                          <Typography variant="body1">{selectedSupplier?.rejectedOrders}</Typography>
                        </Box>
                      </CardContent>
                    </Card>
                  </Box>
                </>
              )}
              {tabValue === 2 && (
                <Box
                  m="0px 0 0 0"
                  height="45vh"
                  sx={{
                    "& .MuiDataGrid-root": {
                      border: "none",
                    },
                    "& .MuiDataGrid-cell": {
                      borderBottom: "none",
                    },
                    "& .MuiDataGrid-columnHeaders": {
                      backgroundColor: colors.blueAccent[700],
                      borderBottom: "none",
                    },
                    "& .MuiDataGrid-virtualScroller": {
                      backgroundColor: colors.primary[400],
                    },
                    "& .MuiDataGrid-footerContainer": {
                      borderTop: "none",
                      backgroundColor: colors.blueAccent[700],
                    },
                  }}
                >
                  {transactions !== null ? 
                    <DataGrid 
                      rows={transactions} 
                      columns={tcolumns} 
                      pageSize={5} 
                      rowsPerPageOptions={[5]} 
                    />
                    :
                    <Typography>No transactions to show.</Typography>
                  }
                </Box>
              )}
              {tabValue === 3 && (
                <>
                  {selectedSupplier?.company?.document ? (
                  <Box sx={{ border: '1px solid #ccc', borderRadius: '4px', overflow: 'hidden', marginTop: 1 }}>
                    <iframe
                        src={pdfUrl}
                        style={{ width: '100%', height: '500px', border: 'none' }}
                        title="Uploaded PDF"
                        onLoad={() => console.log("PDF Loaded")}
                        onError={() => console.error("Error loading PDF")}
                    />
                  </Box>
                  ) : (
                    <Typography>No driver document available.</Typography>
                  )}
                </>
              )}
              {tabValue === 4 && (
                <>
                  {selectedSupplier?.vehicle?.document ? (
                  <Box sx={{ border: '1px solid #ccc', borderRadius: '4px', overflow: 'hidden', marginTop: 1 }}>
                    <iframe
                        src={vurl}
                        style={{ width: '100%', height: '500px', border: 'none' }}
                        title="Uploaded PDF"
                        onLoad={() => console.log("PDF Loaded")}
                        onError={() => console.error("Error loading PDF")}
                    />
                  </Box>
                  ) : (
                    <Typography>No vehicle document available.</Typography>
                  )}
                </>
              )}
            </>
          ) : (
            <Typography>No details available.</Typography>
          )}
        </Box>
        )
        : (
        <Box sx={{ width: 400, height: '100%', padding: 2, backgroundColor: `${colors.primary[400]}` }}>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h6">No Details</Typography>
            <IconButton onClick={handleCloseDrawer}>
              <CloseIcon />
            </IconButton>
          </Box>
          <Typography>No details available.</Typography>
        </Box>
        )}
        {/* </ResizableDrawer> */}
      </Drawer>
    </Box>
  );
};

export default Drivers;